<template>
  <div id="product-documents-ipr-standard-clause-create">

    <standard-clause-form
      v-model="model"
      :apiModel="apiModel"
      ref="form"
      :ProductCompanyType="ProductCompanyType"
      :ProductCompanyType_FK="ProductCompanyType_FK"
    />

    <div class="vx-row">
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-start">
          <vs-button
              :disabled="loading"
              @click="$router.push({ name: `${ProductCompanyType}.standard-clause-ipr.list` })"
              class="my-4"
          >
            Cancel
          </vs-button>
        </div>
      </div>
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
              :disabled="loading"
              @click="create()"
              class="my-4"
              color="light"
          >
            Upload
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import StandardClauseForm from "@/views/pages/product-documents-ipr/standard-clause/StandardClauseForm";
import ProductDocumentCreateMixin from "@/components/mixins/ProductDocumentCreateMixin";
import IprProductCompanyTypeMixin from "@/components/mixins/IprProductCompanyTypeMixin";

export default {
  name: "StandardClauseIprCreate",
  components: {
    StandardClauseForm
  },
  mixins: [ProductDocumentCreateMixin,IprProductCompanyTypeMixin],
  data() {
    return {
      apiModel: this.companyTypeApiModel('productStandardClauseIpr'),
    };
  },
};
</script>

<style scoped>

</style>
